import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { validateFloatInput } from '@gk/gk-modules';
import { MCGRNewRequestSettlementScopeControlName } from '../costs-section/costs-section-form.model';
import {
  MCGRNewRequestAdditionalControlName,
  MCGRNewRequestFormGroup,
} from '../services/new-request-form/new-request-form.model';
import {
  FinancialSectorApplication,
  MCGRFinancialSectorApplicationFormGroup,
  MCGRNewRequestFinancialSectorApplicationControlName,
} from './financial-sector-application-form-array.model';
import { MCGRFinancialSectorApplicationFormArrayService } from './financial-sector-application-form-array.service';

@Component({
  selector: 'app-mcgr-financial-sector-application-form-array',
  templateUrl: './financial-sector-application-form-array.component.html',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
})
export class MCGRFinancialSectorApplicationFormArrayComponent {
  arrayControlName =
    MCGRNewRequestAdditionalControlName.FinancialSectorApplication;
  settlementScopeControlName = MCGRNewRequestSettlementScopeControlName;
  financialSectorApplicationControlName =
    MCGRNewRequestFinancialSectorApplicationControlName;
  @Input() formGroup: FormGroup<MCGRNewRequestFormGroup>;
  @Input() submitted: boolean;

  constructor(
    private mcgrFinancialSectorApplicationFormArrayService: MCGRFinancialSectorApplicationFormArrayService,
  ) {}

  isFormGroupValid(index: number): boolean {
    const letterContentWithParcelsFormGroup = this.getFormArray().at(index);
    return letterContentWithParcelsFormGroup.valid;
  }

  deleteFormControl(index: number): void {
    this.getFormArray().removeAt(index);
  }

  getFormArray(): FormArray<
    FormGroup<MCGRFinancialSectorApplicationFormGroup>
  > {
    return this.formGroup.get(this.arrayControlName) as FormArray<
      FormGroup<MCGRFinancialSectorApplicationFormGroup>
    >;
  }

  addFormControl(): void {
    this.getFormArray().push(
      this.mcgrFinancialSectorApplicationFormArrayService.getFormGroup(),
    );
  }

  validateFloatInput(event: KeyboardEvent): void {
    if (!validateFloatInput(event.key)) {
      event.preventDefault();
    }
  }

  createFormArrayFromData(dataArray: FinancialSectorApplication[]): void {
    const formArray = this.getFormArray();
    formArray?.clear();
    dataArray?.forEach(() => {
      formArray.push(
        this.mcgrFinancialSectorApplicationFormArrayService.getFormGroup(),
      );
    });
  }
}
